export default {"src":"/_next/static/image/public/images/ic_read_prescription.553160bd6279a0986d9eb7f3ed405b8f.svg","height":36,"width":36};